export const BASE_URL = '';
export const PRODUCTS_URL = '/api/products';
export const USERS_URL = '/api/users';
export const ORDERS_URL = '/api/orders';
export const PAYPAL_URL = '/api/config/paypal';
// https://www.paypal.com/sdk/js?client-id=AX6GDy4OSVctObFAFsdpLjifLerWk937EKY52l-GL6BRUqa3X9NuCjAZ84XJwBcItCBMu7A6JtEUIGaI&currency=USD
export const EMAIL_ORDER_INFO_URL = '/api/emails';